<template>
	<div class="container">
		<div>

			<nav-footer v-if="topType" ref="dingbu"></nav-footer>
		</div>
		<!--  -->
		<div class="flex" :class="topType ? 'kandu' : 'denglu'">
			<nav-header v-if="topType" ref="componenta" @custom-event="handleEvent"></nav-header>
			<div class="yangshi_0">
				<!-- <div class="jinbu flex  align-items align-content" v-if="topType">
					<div class="pointer" v-if="myInfo" @click="handleEvent(1)">首页</div>
					<div class="pointer" v-else>个人设置</div>
					<div v-if="type_name">/{{type_name}}</div>
				</div> -->
				<router-view class="yangshi" :class="topType ? 'yangshi_1' : ''" :parentPrint="parentPrint" @ctom-event="gengxin"></router-view>
			</div>
			
		</div>

	</div>
</template>

<script>
	const {
		default: NavFooter
	} = require("@/components/NavFooter.vue")
	const {
		default: NavHeader
	} = require("@/components/NavHeader.vue")

	export default {
		components: {
			NavFooter,
			NavHeader
		},
		data() {
			return {
				type_name:'',
				topType: true,
				myInfo:true,
			}
		},
		watch: {
			//监听路由地址的改变
			$route: {
				immediate: true,
				handler() {
					// console.log(this.$route.path,'路由变化')
					if (this.$route.path == '/index') {
						if (this.$refs.componenta) {
							this.$refs.componenta.type = 0
						}
					}
					if (this.$route.path == '/myInfo') {
						this.myInfo = false
					}
					if (this.$route.path == '/login') {
						this.topType = false
					} else {
						this.topType = true
					}
				}
			}
		},
		methods: {
			handleEvent(item) {
				if(item == 1){
					this.type_name = ''
				}else{
					if(item == 2){ 
						this.type_name = '学习视频' 
					}else if(item == 3){ 
						this.type_name = '卡号管理'
					}else if(item == 4){ 
						this.type_name = '关于我们'
					}else if(item == 5){ 
						this.type_name = '帮助反馈'
					}else if(item == 6){ 
						this.type_name = '用户协议'
					}else if(item == 7){ 
						this.type_name = '隐私政策'
					}
				}
				// console.log(item,'接收参数1')
				this.$refs.dingbu.testB(item);
			},
			gengxin(){
				this.$refs.dingbu.post5c78c4772da97();
			},
			parentPrint() {
				this.$refs.componenta.xinxi();
			},

		}
	}
</script>

<style>
	.align-items {
		align-items: center;
	}

	.yangshi {
		/* background: #F5F6F7 !important; */
		/* padding: 20px; */
		/* border-top: 20px solid #F5F6F7; */
		/* border-left: 20px solid #F5F6F7; */
		/* padding: 20px; */
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		background: #fff;
	}

	.denglu {
		width: 100%;
		
	}

	.bixuan:before {
		content: "*";
		color: #f56c6c;
		margin-right: 4px;
	}

	html {
		padding: 0;
		margin: 0;

	}

	.w1600 {
		width: 1600px;
		margin: 0 auto;
	}

	.w1200 {
		width: 100%;
		min-width: 1200px;
		/* margin: 0 auto; */
	}

	.kandu {
		/* width: calc(100% - 250px) */
		width: 100%;
		
	}
	.yangshi_1{
		/* padding: 20px; */
	}
	.absolute {
		position: absolute;
	}

	.relative {
		position: relative;
	}

	.fixed {
		position: fixed;
	}

	.p1 {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.p2 {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.p3 {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.flex {
		display: flex;

	}

	.justify-content {
		justify-content: center;
	}

	.align-items {
		align-items: center;
	}

	.align-content {
		align-content: center;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.space-between {
		justify-content: space-between;
	}

	.flex-end {
		justify-content: flex-end;
	}

	.pointer {
		cursor: pointer
	}

	.container {
		/* background: #F5F6F7 !important; */
	}

	.bodycolor {
		color: #0DC3D6 !important;
	}

	.borderBottm {
		border-bottom: 1px dashed #0DC3D6 !important;
	}

	.justify-content {
		justify-content: center;
	}

	img {
		width: 100%;
	}

	.scroll-box::-webkit-scrollbar {
		display: none !important;
	}
	
	
	
	
	
	.jinbu{
		height: 66px;
		background: #F8F8F8;
		width: 100%;
		padding: 0 20px;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}
	.yangshi_0{
		width: 100%;
		
	}
</style>